import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { createStyles, getStylesRef, rem } from '@mantine/core'

type StylesParams = {
  layout: 'vertical' | 'horizontal'
  carouselItemLayout: 'inline' | 'group'
  itemLength: number
}

export default createStyles(
  (theme, { layout, carouselItemLayout, itemLength }: StylesParams) => {
    const verticalLayout = layout === 'vertical'
    const horizontalLayout = layout === 'horizontal'

    const horizontalLayoutAndGroupItem =
      layout === 'horizontal' && carouselItemLayout === 'group'
    const horizontalLayoutAndInlineItem =
      layout === 'horizontal' && carouselItemLayout === 'inline'
    return {
      root: {
        display: 'flex',
        [theme.fn.smallerThan('sm')]: {
          flexDirection: 'column',
          gap: 8,
        },
        [theme.fn.largerThan('sm')]: {
          gap: rem(24),
          alignItems: 'center',
          justifyContent: 'center',
          ...(verticalLayout && {
            flexDirection: 'column',
            gap: 80 - 24,
          }),
          ...(horizontalLayoutAndInlineItem && {
            gap: 80,
          }),
        },
      },
      listing: {
        display: 'flex',
        gap: rem(16),
        ...(horizontalLayout && {
          flexShrink: 0,
        }),
        ...((verticalLayout || horizontalLayoutAndInlineItem) && {
          '.carouselCard': {
            width: '100%',
          },
        }),
        [theme.fn.smallerThan('sm')]: {
          flexDirection: 'column',
        },
        [theme.fn.largerThan('sm')]: {
          flexWrap: 'wrap',
          gap: rem(24),
          ...(horizontalLayoutAndGroupItem && {
            order: 1,
            maxWidth: rem(648),
          }),
          ...(verticalLayout && {
            width: '100%',
          }),
          ...(horizontalLayoutAndInlineItem && {
            flex: 1,
          }),
          '.slide-item': {
            ...(carouselItemLayout === 'group' && {
              height: 'auto',
              '&[data-item="4"]': {
                paddingBottom: 80,
                [`.${getStylesRef('item')}`]: {
                  '&:nth-child(even)': {
                    transform: `translate(0, ${rem(80)})`,
                  },
                },
              },
              '&[data-item="3"]': {
                justifyContent: 'flex-end',
                [`.${getStylesRef('item')}`]: {
                  '&:nth-child(1)': {
                    transform: `translate(0, 50%)`,
                  },
                },
              },
              '&[data-item="2"]': {
                [`.${getStylesRef('item')}`]: {
                  '&:nth-child(2)': {
                    marginTop: 80,
                  },
                },
              },
              ...(itemLength === 1 && {
                '&[data-item="1"]': {
                  '& > div': {
                    flex: '0 0 100%',
                    maxWidth: '100%',
                  },
                },
              }),
            }),
          },
        },
      },
      carousel: {},
      info: {
        [theme.fn.largerThan('sm')]: {
          ...(horizontalLayoutAndGroupItem && {
            width: '100%',
            order: 2,
          }),
          ...(horizontalLayoutAndInlineItem && {
            flex: 1,
          }),
        },
      },
      infoInner: {
        gap: 0,
        [theme.fn.largerThan('sm')]: {
          ...(horizontalLayoutAndGroupItem && {
            width: rem(360),
            ...(itemLength > 1
              ? {
                  margin: '0 auto',
                }
              : {
                  marginLeft: 40,
                }),
          }),
        },
      },
      title: {
        [theme.fn.largerThan('sm')]: {
          ...(verticalLayout && {
            textAlign: 'center',
          }),
        },
      },
      item: {
        ref: getStylesRef('item'),
        [theme.fn.largerThan('sm')]: {
          ...(carouselItemLayout === 'group' && {
            flex: '0 0 calc(50% - 12px)',
          }),
        },
      },
      embedItem: {
        [theme.fn.largerThan('sm')]: {
          ...(carouselItemLayout === 'group' && {
            height: 354,
          }),
          ...(carouselItemLayout === 'inline' && {
            height:
              itemLength === 1 || itemLength === 2
                ? 320
                : itemLength === 3
                ? 332
                : 386,
          }),
        },
      },
      editorContent: {
        'p, ul': {
          margin: `${rem(16)} 0`,
        },
        li: {
          position: 'relative',
          paddingLeft: rem(44),
          marginTop: rem(16),
          '&:first-of-type': {
            marginTop: 0,
          },
          '&:before': {
            content: '""',
            display: 'inline-block',
            width: rem(28),
            height: rem(28),
            background: `url(${CommonGAssets.getAssetPath('check-green.svg')})`,
            backgroundPosition: 'center',
            backgroundColor: theme.colors.green[0],
            backgroundRepeat: 'no-repeat',
            borderRadius: '50%',
            position: 'absolute',
            top: rem(-2),
            left: 0,
          },
        },
      },
    }
  },
)
